<ngx-emoji
  *ngIf="emojiName"
  class="emoji"
  [emoji]="emojiName"
  [size]="size"
  [ngStyle]="{ height: size + 'px' }"
  [backgroundImageFn]="emojiSheet"
  (click)="clicked.emit(emojiName)"
></ngx-emoji>
